import axios from "../../../common/config/axios";
import * as types from "./types";

export const getList = (data) => dispatch => {
    axios.get("agent_promote_link/list", {params: data})
    .then((res) => {
        dispatch({
            type: types.AGENT_PROMOTE_LINK_LIST,
            payload: res.data
        });
    })
    .catch((err) => {
        // dispatch({
        //     type: types.AGENT_PROMOTE_LINK_LIST,
        //     payload: []
        // });
    });
};

export const storePromoteLink = (data) => dispatch => {
    axios.post("agent_promote_link/store", data)
    .then((res) => {
        dispatch({
            type: types.AGENT_PROMOTE_LINK_CREATE,
            payload: res.data
        });
    })
    .catch((err) => {
        // dispatch({
        //     type: types.AGENT_PROMOTE_LINK_CREATE,
        //     payload: []
        // });
    });
};

export const showPromoteLink = (data) => dispatch => {
    axios.get("agent_promote_link/show", {params: data})
    .then((res) => {
        dispatch({
            type: types.AGENT_PROMOTE_LINK_SHOW,
            payload: res.data
        });
    })
    .catch((err) => {
        // dispatch({
        //     type: types.AGENT_PROMOTE_LINK_SHOW,
        //     payload: []
        // });
    });
};

export const statusPromoteLink = (data) => dispatch => {
    axios.post('agent_promote_link/status', data)
    .then((res) => {
        dispatch({
            type: types.AGENT_PROMOTE_LINK_STATUS,
            payload: res.data
        });
    })
    .catch((err) => {
        // dispatch({
        //     type: types.AGENT_PROMOTE_LINK_STATUS,
        //     payload: []
        // });
    });
};